exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "empty{display:flex;padding:100px;justify-content:center}empty h3{color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/utility/empty/empty.scss
// module id = 869
// module chunks = 0